import { render, staticRenderFns } from "./AttendanceTeach.vue?vue&type=template&id=004f7ab0&scoped=true&"
import script from "./AttendanceTeach.vue?vue&type=script&lang=js&"
export * from "./AttendanceTeach.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceTeach.vue?vue&type=style&index=0&id=004f7ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f7ab0",
  null
  
)

export default component.exports